module.exports = __webpack_public_path__ + "static/media/logo_normandie.850ee9e6.jpg";